import { RouteRecordRaw } from "vue-router";

const PatternAndTenderForm = () => import("@/components/waybilling/PatternAndTenderForm.vue");
const ViewTender = () => import("@/components/waybilling/ViewTender.vue");
const WaybillsList = () => import("@/components/waybilling/WaybillsList.vue");
const PatternsList = () => import("@/components/waybilling/PatternsList.vue");
const WaybillingPage = () => import("@/pages/waybilling/WaybillingPage.vue");

const routes: RouteRecordRaw = {
  name: "waybillingPage",
  path: "/waybilling",
  component: WaybillingPage,
  meta: {
    authenticated: true,
    permissions: ["waybilling_booking_requests", "waybilling_patterns"],
    breadcrumbs: [
      { label: "Booking" },
      { label: "Booking Requests", to: "waybillsList", on: ["waybillsList"] },
      { label: "Patterns", to: "patternsList", on: ["patternsList"] },
      { label: "Pattern Management", to: "createPattern", on: ["createPattern"] },
      { label: "Create Tender", to: "createTender", on: ["createTender"] },
      { label: "Tender Request", to: "replayTenderRequest", on: ["replayTenderRequest"] },
      { label: "Tender Request", to: "viewTenderRequest", on: ["viewTenderRequest"] },
    ],
  },
  children: [
    {
      name: "waybillsList",
      path: ":customerId/waybills",
      component: WaybillsList,
      props: true,
      meta: {
        title: `Booking`,
        permissions: ["waybilling_booking_requests"],
      },
    },
    {
      name: "patternsList",
      path: ":customerId/patterns",
      component: PatternsList,
      props: true,
      meta: {
        title: `Pattern Management`,
        permissions: ["waybilling_patterns"],
      },
    },
    {
      name: "createPattern",
      path: ":customerId/pattern/create",
      component: PatternAndTenderForm,
      props: true,
      meta: {
        title: `Create Pattern`,
      },
    },
    {
      name: "editPattern",
      path: ":customerId/pattern/:patternId/edit",
      component: PatternAndTenderForm,
      props: true,
      meta: {
        title: `Edit Pattern`,
      },
    },
    {
      name: "createTender",
      path: ":customerId/pattern/:patternId/create-tender",
      component: PatternAndTenderForm,
      props: true,
      meta: {
        title: `Create Tender`,
      },
    },
    {
      name: "viewTenderRequest",
      path: ":customerId/tender-request/:requestId/view",
      component: ViewTender,
      props: true,
      meta: {
        title: `View Tender Request`,
      },
    },
    {
      name: "replayTenderRequest",
      path: ":customerId/tender-request/:requestId/replay",
      component: PatternAndTenderForm,
      props: true,
      meta: {
        title: `Replay Tender Request`,
      },
    },
  ],
};

export default routes;
